module.exports = __webpack_public_path__ + "img/Air8ChatBotLogoEnter.f6e176e4.png";